import { JobStatus, JobType } from '@kcftech/prometheus-client';
import { Lookup } from 'utils/types';

// TODO: this should be a mapping returned by the API
// Note: EditGroups does not have a display name because it hasn't been implemented yet.
// Intentionally leaving its display name blank.
export const jobTypeToName: Lookup<JobType, string> = {
    SensorAssignment: 'Sensor Assignment',
    SystemCreation: 'System Creation',
    EditAssetDetails: 'Edit Asset Details',
    EditIndicators: 'Edit Indicators',
    EditGroups: '',
    AlertThresholdGeneration: 'Alert Threshold Generation',
};

export const jobStatusToName: Lookup<JobStatus, string> = {
    Queued: 'Queued',
    Running: 'Running',
    Finished: 'Finished',
    FinishedWithErrors: 'Finished with errors',
    Errored: 'Errored',
    Deferred: 'Deferred',
};
